import { forwardRef } from 'react';
import type { LucideProps } from 'lucide-react';

/**
 * Auricular con engranaje: el ícono del soporte de sistemas cliente.
 *
 * Mismo lenguaje que lucide (caja de 24, trazo 2, puntas redondas) y las mismas
 * props, así entra donde entra un `LucideIcon` (tabs, EmptyState, la campana)
 * sin adaptadores. lucide trae `Headset`, pero no el engranaje que lo distingue
 * de "audio": esto es atender un sistema, no escuchar.
 */
export const SupportIcon = forwardRef<SVGSVGElement, LucideProps>(function SupportIcon(
  { size = 24, strokeWidth = 2, className, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      {/* la vincha */}
      <path d="M4 13a8 8 0 0 1 16 0" />
      {/* los dos auriculares */}
      <rect x="3" y="12" width="3.5" height="6" rx="1.5" />
      <rect x="17.5" y="12" width="3.5" height="6" rx="1.5" />
      {/* el micrófono */}
      <path d="M19.25 18v1.5a1.5 1.5 0 0 1-1.5 1.5H15" />
      {/* el engranaje: centro y seis dientes */}
      <circle cx="12" cy="14" r="2.2" />
      <path d="M12 10.8V9.4M12 17.2v1.4M14.77 12.4l1.21-.7M9.23 12.4l-1.21-.7M9.23 15.6l-1.21.7M14.77 15.6l1.21.7" />
    </svg>
  );
});
